export const GET_ACCOUNT_KYB_STATUS = `
  query getAccountKYBStatus {
    getAccountKYBStatus {
      caseId
      status
    }
  }
`;

export const GET_APPROVED_PAYMENT_METHODS_FOR_ONGOING_KYB = `
  query getApprovedPaymentMethodsForOngoingKyb {
    getApprovedPaymentMethodsForOngoingKyb {
      paymentMethodName
      paymentMethodProvider
      shopperCountry
      type
    }
  }
`;

export const GET_CLIENT_LEGAL_ENTITY = `
  query getClientLegalEntity {
    getClientLegalEntity {
      id
      profile {
        businessDetails {
          address {
            countryCode
            postcode
            state {
              english
              local
            }
            streetAddresses {
              english
              local
            }
            suburb {
              english
              local
            }
          }
          descriptionOfGoodsOrServices
          industryCategory {
            categoryCode
          }
          tradingName
        }
      }
    }
  }
`;

export const GET_DRAFT = `
  query getDraft($draftType: DraftType) {
    getDraft(draftType: $draftType)
  }
`;

export const GET_FILE_UPLOAD_TOKEN = `
  query getFileUploadToken($mime_types: [String]) {
    getFileUploadToken(mime_types: $mime_types) {
      endpoint
      form_data
      id
    }
  }
`;

export const GET_I18N_CONTENT = `
  query getI18nContent($langKey: String!) {
    getI18nContent(langKey: $langKey) {
      i18nContentImage {
        image {
          mimeType
          title
          url
        }
        key
      }
      i18nContentLabel {
        key
        label
      }
    }
  }
`;

export const GET_IN_PROGRESS_PAYMENT_METHODS_FOR_INCREMENTAL_PAYMENT_ACTIVATION = `
  query getInProgressPaymentMethodsForIncrementalPaymentActivation(
    $caseId: String
    $langKey: String!
  ) {
    getInProgressPaymentMethodsForIncrementalPaymentActivation(
      caseId: $caseId
      langKey: $langKey
    ) {
      code
      name
      requireReserve
      status
    }
  }
`;

export const GET_IN_PROGRESS_PAYMENT_METHODS_FOR_INITIAL_PAYMENT_ACTIVATION = `
  query getInProgressPaymentMethodsForInitialPaymentActivation(
    $langKey: String!
  ) {
    getInProgressPaymentMethodsForInitialPaymentActivation(langKey: $langKey) {
      code
      name
      requireReserve
      status
    }
  }
`;

export const GET_IN_PROGRESS_PAYMENT_METHODS_FOR_SELECT_RESERVE = `
  query getInProgressPaymentMethodsForSelectReserve(
    $activatedPaymentMethods: [ActivatedPaymentMethodInput]
    $langKey: String!
  ) {
    getInProgressPaymentMethodsForSelectReserve(
      activatedPaymentMethods: $activatedPaymentMethods
      langKey: $langKey
    ) {
      code
      name
      requireReserve
      status
    }
  }
`;

export const GET_IN_REVIEW_PAYMENT_METHODS = `
  query getInReviewPaymentMethods {
    getInReviewPaymentMethods {
      paymentMethodName
      paymentMethodProvider
      shopperCountry
      type
    }
  }
`;

export const GET_MERCHANT_DATA = `
  query getMerchantData {
    getMerchantData {
      profile {
        accountId
        legalEntityId
        paymentMethods {
          paymentMethodName
          paymentMethodProvider
          shopperCountry
          type
        }
        paymentTypeDistribution {
          paymentType
          ratio
        }
      }
    }
  }
`;

export const GET_MID_RATE = `
  query getMidRate($buyCcy: String!) {
    getMidRate(buyCcy: $buyCcy) {
      buyCcy
      rate
      rateType
      sellCcy
    }
  }
`;

export const GET_NEW_PAYMENT_METHOD_REQUIRED_INFO = `
  query getNewPaymentMethodRequiredInfo($paymentMethods: [String]) {
    getNewPaymentMethodRequiredInfo(paymentMethods: $paymentMethods) {
      fulfillmentDaysRequired
      paymentTypeDistributionRequired
      websiteRequired
    }
  }
`;

export const GET_ONGOING_CASE = `
  query getOngoingCase($caseId: String) {
    getOngoingCase(caseId: $caseId) {
      accountId
      additionalInfo {
        proposedReserveOffer {
          coverage
          currency
          customizedReserve {
            delayedDays
            rollingDays
            rollingRate
          }
          delayedDays
          disabledOptions
          exposure
          fixedAmount
          mandatoryDelayedDays
          rollingDays
          rollingDays2
          rollingRate
          rollingRate2
        }
      }
      caseType
      createAt
      id
      legalEntityId
      owningEntity
      requests {
        accountId
        newPaymentMethods {
          paymentMethodName
          paymentMethodProvider
          shopperCountry
          type
        }
      }
      status
    }
  }
`;

export const GET_PAYMENT_METHODS = `
  query getPaymentMethods($langKey: String!) {
    getPaymentMethods(langKey: $langKey) {
      activationTimeMax
      activationTimeMin
      code
      description
      isPopular
      locations
      name
      productTypes
      requireReserve
      requiresOnlineWebsiteUrl
      type
    }
  }
`;

export const GET_PLATFORM_PAYMENT_METHODS = `
  query getPlatformPaymentMethods(
    $langKey: String!
    $platformAccountId: String!
  ) {
    getPlatformPaymentMethods(
      langKey: $langKey
      platformAccountId: $platformAccountId
    ) {
      allowedSelection
      paymentMethods {
        activationTimeMax
        activationTimeMin
        code
        description
        isPopular
        locations
        name
        productTypes
        requireReserve
        requiresOnlineWebsiteUrl
        type
      }
    }
  }
`;

export const GET_PLATFORM_PAYMENTS_TYPE = `
  query getPlatformPaymentsType($platformAccountId: String!) {
    getPlatformPaymentsType(platformAccountId: $platformAccountId) {
      platformPaymentsType
    }
  }
`;

export const GET_RESERVE_OPTIONS = `
  query getReserveOptions($langKey: String!) {
    getReserveOptions(langKey: $langKey) {
      currentReserveOffer {
        currency
        customizedReserve {
          delayedDays
          rollingDays
          rollingRate
        }
        delayedDays
        disabledOptions
        fixedAmount
        mandatoryDelayedDays
        rollingDays
        rollingDays2
        rollingRate
        rollingRate2
      }
      currentReserveOfferSourceCaseId
      paymentMethodsNeedReserve
      previousChoice
      previousReserveOffer {
        currency
        customizedReserve {
          delayedDays
          rollingDays
          rollingRate
        }
        delayedDays
        disabledOptions
        fixedAmount
        mandatoryDelayedDays
        rollingDays
        rollingDays2
        rollingRate
        rollingRate2
      }
      previousReserveOfferSourceCaseId
    }
  }
`;

export const GET_RESERVE_OPTIONS_FOR_ONGOING_KYB = `
  query getReserveOptionsForOngoingKyb($caseId: String, $langKey: String!) {
    getReserveOptionsForOngoingKyb(caseId: $caseId, langKey: $langKey) {
      currentReserveOffer {
        currency
        customizedReserve {
          delayedDays
          rollingDays
          rollingRate
        }
        delayedDays
        disabledOptions
        fixedAmount
        mandatoryDelayedDays
        rollingDays
        rollingDays2
        rollingRate
        rollingRate2
      }
      currentReserveOfferSourceCaseId
      paymentMethodsNeedReserve
      previousChoice
      previousReserveOffer {
        currency
        customizedReserve {
          delayedDays
          rollingDays
          rollingRate
        }
        delayedDays
        disabledOptions
        fixedAmount
        mandatoryDelayedDays
        rollingDays
        rollingDays2
        rollingRate
        rollingRate2
      }
      previousReserveOfferSourceCaseId
    }
  }
`;

export const GET_SCALE_SETTING_BY_PLATFORM_ACCOUNT_ID = `
  query getScaleSettingByPlatformAccountId($platformAccountId: String!) {
    getScaleSettingByPlatformAccountId(platformAccountId: $platformAccountId) {
      scaleConnectionSetting {
        defaultConnectionPermission {
          defaultPermissionToConnectedAccount {
            permissionContext
            permissions
          }
        }
        id
        platformAccountSetting {
          allowSkipBusinessRegistrationDocVerification
          awxAsksForPermissionApproval
          billingModel
          canConnectExistingAccount
          canDownloadConnectedAccountsOnboardingDocs
          canUpdateClientType
          clientType
          componentTheme
          enabled
          merchantBusinessTypes
          platformCustomEmailSenderAddress
          platformEmailForConnectedAccountRFI
          sendConnectedAccountRFIToPlatform
          useCustomEmailSenderAddress
        }
      }
    }
  }
`;

export const GET_USER_PAYMENT_METHODS_STATUS = `
  query getUserPaymentMethodsStatus($langKey: String!) {
    getUserPaymentMethodsStatus(langKey: $langKey) {
      pmList {
        code
        name
        requireReserve
        status
      }
    }
  }
`;

export const GET_USER_RESERVE_PLAN = `
  query getUserReservePlan {
    getUserReservePlan {
      autoAccepted
      currency
      currentReserveOffer {
        currency
        customizedReserve {
          delayedDays
          rollingDays
          rollingRate
        }
        delayedDays
        disabledOptions
        fixedAmount
        mandatoryDelayedDays
        rollingDays
        rollingDays2
        rollingRate
        rollingRate2
      }
      currentReserveOfferSourceCaseId
      delayedDays
      fixedAmount
      kybOnboarded
      mandatoryDelayedDays
      previousChoice
      previousReserveOffer {
        currency
        customizedReserve {
          delayedDays
          rollingDays
          rollingRate
        }
        delayedDays
        disabledOptions
        fixedAmount
        mandatoryDelayedDays
        rollingDays
        rollingDays2
        rollingRate
        rollingRate2
      }
      previousReserveOfferSourceCaseId
      rollingDays
      rollingRate
    }
  }
`;

export const GET_USER_SELECTED_PAYMENT_METHODS = `
  query getUserSelectedPaymentMethods($langKey: String!) {
    getUserSelectedPaymentMethods(langKey: $langKey) {
      code
      name
      requireReserve
      status
    }
  }
`;

export const ADD_PAYMENT_METHODS = `
  mutation addPaymentMethods(
    $addPaymentMethodsRequest: AddPaymentMethodsRequest!
  ) {
    addPaymentMethods(addPaymentMethodsRequest: $addPaymentMethodsRequest) {
      message
      ongoingCaseId
      ongoingCaseStatus
      status
    }
  }
`;

export const ADD_SUPPLEMENTAL_FILES = `
  mutation addSupplementalFiles($fileUris: [String!]!) {
    addSupplementalFiles(fileUris: $fileUris) {
      status
    }
  }
`;

export const SAVE_DRAFT = `
  mutation saveDraft($draft: String!, $draftType: DraftType) {
    saveDraft(draft: $draft, draftType: $draftType) {
      status
    }
  }
`;

export const SELECT_RESERVE = `
  mutation selectReserve(
    $caseId: String!
    $userSelection: UserReserveSelection!
  ) {
    selectReserve(caseId: $caseId, userSelection: $userSelection) {
      status
    }
  }
`;

export const SUBMIT_KYB = `
  mutation submitKyb($evaluateRequest: EvaluateRequestInput!) {
    submitKyb(evaluateRequest: $evaluateRequest) {
      status
    }
  }
`;
